var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1573546876961,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10793,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M787.247209 544.492566c1.316436 155.083477 135.666046 206.314779 137.238456 206.863295-0.731353 3.620199-21.026409 73.976391-71.343519 145.429612-42.052817 62.896388-86.189992 124.366637-156.14394 125.463667-68.015861 1.57241-90.870653-40.005028-168.869488-40.005028-78.730188 0-103.120822 38.907998-168.284405 41.577438-66.662858 2.486601-117.638186-67.138237-161.226845-129.449543-87.067616-127.255482-154.900639-358.655681-63.993418-516.079489 44.100607-77.230913 124.47634-126.926373 210.337223-128.279376 66.735993-1.353004 128.681621 45.051366 169.673976 45.051366 40.224434 0 116.797129-55.509719 195.746723-47.245427 33.020604 0.950759 127.072644 13.01809 187.665269 101.475277-4.900067 2.925413-111.970197 65.894937-110.800032 195.198208zM658.784994 164.152259c-36.567667 43.149847-95.14907 76.170451-152.194632 71.928601-7.459804-58.252294 21.428653-120.23449 53.754471-158.045458C596.949068 35.104961 660.467106 2.230628 711.259596 0c6.618748 60.592625-17.333074 120.23449-52.438035 164.152259z",
    "p-id": 10794
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApple);
export default __webpack_public_path__ + "static/media/download-apple.f5a226291e7d6e3bc00c3a3aaf25c2e8.svg";
export { ForwardRef as ReactComponent };